import React, { useState } from 'react';
import styles from './companySettings.module.scss';
import {
    Route,
    Switch,
    Redirect,
    NavLink
} from 'react-router-dom';
import { Col } from 'react-bootstrap';
import General from './offer-approvals';
import CustomNavbar from '../customNavbar';
import { useHistory } from "react-router-dom";

const Approvals = (props) => {

    let [isURLLoading, setURLLoading] = useState(false);

    const breadcrumb = [
        {
            pathaddress: '',
            pathname: 'Approvals',
            isActive: true,
            key: 1 + 'Approvals'
        }
    ];

    let history = useHistory();

    let main_props = {
        permissions: props.permissions,
        role: props.role,
        toggleInterviewView: props.toggleInterviewView,
        GetTaskValues: props.GetTaskValues,
        userAlerts: props.userAlerts
    }

    return (
        <div className={styles.settingsBodyContainer}>
            <div className={styles.backgroundFixedComponents}>
                <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} />
            </div>
            <div className={styles.companySettingsBodyWrapper}>
                <ul className={styles.tabOptionsContainer}>
                    <NavLink to="/app/company/approvals" activeClassName={styles.subCategoryContainerActive} className={styles.subCategoryContainer}>
                        <li className={styles.switchActive}> <p className={styles.settingsContentSwitch}>Offer Approvals</p></li>
                    </NavLink>
                </ul>
                <Switch>
                    <Route path='/app/company/approvals' exac={true} render={props => <General main_props={main_props}  {...props} />} />
                    {/* <Route path='/app/company/settings/integrations' exac={true} render={props => <Integrations main_props={main_props} {...props} />} /> */}
                    <Redirect from="/" to="/app/company/approvals" />
                </Switch>
            </div>
        </div>
    )
}

export default Approvals;